module.exports = __webpack_public_path__ + "img/userInfo.798a76d.svg";